import setAlign from './setAlign';

/**
 * Set align content attribute to node's Yoga instance
 *
 * @param {String} align value
 * @param {Object} node instance
 * @return {Object} node instance
 */
const setAlignContent = setAlign('content');

export default setAlignContent;
